import request from '@/utils/request'


// 查询提现申请记录列表
export function listWithdrawApply(query) {
  return request({
    url: '/biz/admin/user/withdraw/apply/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询提现申请记录分页
export function pageWithdrawApply(query) {
  return request({
    url: '/biz/admin/user/withdraw/apply/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询提现申请记录详细
export function getWithdrawApply(data) {
  return request({
    url: '/biz/admin/user/withdraw/apply/detail',
    method: 'get',
    params: data
  })
}

// 修改提现申请记录
export function auditWithdrawApply(data) {
  return request({
    url: '/biz/admin/user/withdraw/apply/audit',
    method: 'post',
    data: data
  })
}

// 删除提现申请记录
export function delWithdrawApply(data) {
  return request({
    url: '/biz/admin/user/withdraw/apply/delete',
    method: 'post',
    data: data
  })
}
